<template>
  <div id="app">

    <transition name="fade">
      <router-view  v-if="isRouterAlive"/>
    </transition>
    <div class="loading-box" v-if="isLoading">
      <nt-pulse-loader :loading="isLoading"></nt-pulse-loader>
    </div>
    <transition name="el-zoom-in-center">
      <nt-preview-image v-if="previewImgUrl"></nt-preview-image>
    </transition>
    <!-- <transition name="el-zoom-in-center" v-if="isAuth">
      <nt-auth></nt-auth>
    </transition> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'App',
    computed:{
      ...mapState(['isLoading','previewImgUrl','isAuth'])
    },
    provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return {
        isRouterAlive:true,
      }
    },
    mounted(){
      this.$store.commit("SHOW_PREVIEW_IMG", '');
    },
    methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        })
      }
    }
  }
</script>

<style>
  #app {
    height: 100%;
    text-align: center;
    color: #000;

  }
  .viewer-container {
    z-index: 3001!important;
  }
</style>



// WEBPACK FOOTER //
// App.vue?da492d84